import React from 'react';
import { Clock } from 'lucide-react';
import { COUNTDOWN_WARN_SECONDS, formatCountdown } from '@/utils/timeLimit';

interface QuizTimerProps {
  secondsRemaining: number;
}

/**
 * The wall clock on a timed trial block — plum while there is room, gold in the
 * last minute (the .pen's accent/celebrate pair).
 *
 * The count is not a live region: read every second it would talk over the
 * question. Only the one-minute warning announces, which is the moment that
 * changes what the learner should do.
 */
export const QuizTimer: React.FC<QuizTimerProps> = ({ secondsRemaining }) => {
  const warning = secondsRemaining <= COUNTDOWN_WARN_SECONDS;
  const label = formatCountdown(secondsRemaining);

  return (
    <div
      data-testid="quiz-block-timer"
      data-warning={warning ? 'true' : 'false'}
      className={`flex flex-shrink-0 items-center gap-1.5 rounded-full border-2 px-3 py-1.5 font-sans text-sm font-extrabold tabular-nums ${
        warning
          ? 'border-celebrate-500 bg-celebrate-50 text-celebrate-on'
          : 'border-accent-200 bg-accent-50 text-accent-700'
      }`}
    >
      <Clock className="h-4 w-4" aria-hidden="true" />
      <span aria-hidden="true">{label}</span>
      <span className="sr-only">{`${label} remaining`}</span>
      <span role="status" aria-live="polite" className="sr-only">
        {warning ? 'One minute left' : ''}
      </span>
    </div>
  );
};
